/**
 * Catálogo de textos em português brasileiro para o recurso de Livros & Regras
 * (`@gamecodex/world-ui` → `features/books`).
 *
 * As chaves espelham as chamadas `t('books.*')` nos componentes React do recurso. Os valores
 * são as cadeias de caracteres exatas traduzidas para o português brasileiro.
 */
export const booksPtBR = {
  // BackerDownloadModal.tsx
  'books.backerModal.title': 'Resgate seu PDF de Apoiador',
  'books.backerModal.sendLinkError': 'Não conseguimos enviar seu link de login agora. Tente novamente em breve.',
  'books.backerModal.checkInboxPrefix': 'Verifique sua caixa de entrada em',
  'books.backerModal.checkInboxSuffix':
    'Se você apoiou com esse e-mail, um link de login está a caminho — clique nele para resgatar sua cópia.',
  'books.backerModal.linkAutoSignIn': 'O link se abre neste site e o faz login automaticamente. Nenhuma senha necessária.',
  'books.backerModal.signInIntro':
    'Digite o e-mail com o qual você apoiou. Enviaremos um link de login com um clique, depois prepararemos sua cópia pessoal.',
  'books.backerModal.pledgeEmailLabel': 'E-mail da conta de apoio',
  'books.backerModal.emailLinkCta': 'Envie-me um link de login',
  'books.backerModal.prepareTimeout':
    'Sua cópia está demorando mais do que o esperado para ser preparada. Tente novamente em alguns minutos.',
  'books.backerModal.notEntitled': 'Você está logado, mas seu apoio não inclui este livro.',
  'books.backerModal.notClaimable': 'Este livro não é oferecido como download para apoiadores.',
  'books.backerModal.prepareError': 'Não conseguimos preparar seu download agora. Tente novamente em breve.',
  'books.backerModal.signedInAs': 'Logado como',
  'books.backerModal.signOut': 'Fazer logout',
  'books.backerModal.verified': 'Verificado',
  'books.backerModal.welcomeBack': ' — bem-vindo de volta,',
  'books.backerModal.backerNumber': '(Apoiador #{number})',
  'books.backerModal.copyReady':
    'Sua cópia pessoal está pronta. Este link é pessoal e expira em breve — não o compartilhe.',
  'books.backerModal.downloadPdf': 'Baixe seu PDF',
  'books.backerModal.dtrpgEmailLabel': 'E-mail da conta DriveThruRPG',
  'books.backerModal.optional': '(opcional)',
  'books.backerModal.dtrpgWarn':
    'Adicione isso também para espelhar a compra em sua biblioteca DriveThruRPG. Pule isso e sua cópia continua disponível aqui para download.',
  'books.backerModal.preparingCopy': 'Preparando sua cópia…',
  'books.backerModal.prepareDownload': 'Preparar & Baixar',

  // BackerVerifyPage.tsx
  'books.backerVerify.missingToken': 'Este link de login está faltando seu token. Solicite um novo link na página do livro.',
  'books.backerVerify.invalidToken':
    'Este link de login é inválido ou expirou. Solicite um novo na página do livro.',
  'books.backerVerify.seoTitle': 'Login de apoiador',
  'books.backerVerify.seoDescription': 'Verificando seu link de login de apoiador Grymwyrd.',
  'books.backerVerify.confirming': 'Confirmando seu login de apoiador…',
  'books.backerVerify.signedInHeading': 'Você está logado',
  'books.backerVerify.signedInAs': 'Logado como',
  'books.backerVerify.headBackPrefix': 'Volte ao livro e clique em',
  'books.backerVerify.downloadWord': 'Baixar',
  'books.backerVerify.headBackSuffix': 'para resgatar sua cópia.',
  'books.backerVerify.backToBook': 'Voltar ao seu livro',
  'books.backerVerify.browseAthenaeum': 'Navegar pela Athenaeum',
  'books.backerVerify.problemHeading': 'Problema no link de login',

  // BookCard.tsx
  'books.card.viewAria': 'Ver {title}',
  'books.card.coverAlt': 'Capa de {title}',
  'books.card.owned': 'Possuído',

  // BookCover.tsx
  'books.cover.coverAlt': 'Capa de {title}',

  // BookStorePage.tsx
  'books.store.seoTitle': 'Livros & Regras',
  'books.store.seoDescription':
    'Tomes do crepúsculo eterno — livros de regras básicos, o SRD ilustrado e aventuras grimdark. Compre para desbloquear módulos e ganhe moedas.',
  'books.store.eyebrow': 'A Athenaeum',
  'books.store.heading': 'Livros & Regras',
  'books.store.intro':
    'Adquira os tomos que unem o mundo. Cada compra desbloqueia módulos jogáveis em suas campanhas e o recompensa com moedas para a economia do mundo.',
  'books.store.filterAria': 'Filtrar livros por tipo',
  'books.store.filterAll': 'Todos',
  'books.store.loading': 'Quebrando o lacre do arquivo…',
  'books.store.empty': 'Nenhum tome corresponde a esta categoria ainda. Os escribas ainda estão trabalhando.',

  // BuyButton.tsx
  'books.buy.checkoutUnavailable': 'O checkout não está disponível ainda. Tente novamente em breve.',
  'books.buy.signInToClaim': 'Faça login para resgatar este tome.',
  'books.buy.ledgerSealed': 'O livro-razão do comerciante está lacrado por enquanto — o checkout em breve.',
  'books.buy.inLibrary': 'Em Sua Biblioteca',
  'books.buy.openingVault': 'Abrindo o cofre…',
  'books.buy.claimFree': 'Resgatar Gratuitamente',
  'books.buy.buyPrice': 'Comprar — {price}',
  'books.buy.unlockPrefix': 'Comprar → desbloquear módulos +',
  'books.buy.coinsSuffix': '{coins} moedas',

  // BookDetailPage.tsx
  'books.detail.loading': 'Virando as páginas…',
  'books.detail.backToAthenaeum': 'Voltar à Athenaeum',
  'books.detail.unlockOwned': 'Você possui este tome — seu conhecimento de Grymwyrd é desbloqueado em toda a enciclopédia.',
  'books.detail.unlockClaim': 'Resgate este tome para desbloquear seu conhecimento de Grymwyrd em toda a enciclopédia.',
  'books.detail.returnTo': 'Voltar para {label}',
  'books.detail.backerCta': 'Apoiador? Baixe seu PDF',
  'books.detail.coinsEarned': 'Você ganhou {coins} moedas com esta compra.',
  'books.detail.coinsGranted': 'A compra concede {coins} moedas ao seu tesouro.',
  'books.detail.byAuthor': 'Por {author}',
  'books.detail.statPrice': 'Preço',
  'books.detail.statPages': 'Páginas (última renderização)',
  'books.detail.statWords': 'Palavras (última renderização)',
  'books.detail.ofThisTome': 'Deste Tome',
  'books.detail.noDescription': 'Nenhuma descrição foi inscrita para este volume ainda.',
  'books.detail.previewHeading': 'Pré-visualização',
  'books.detail.previewBlurb': 'Vislumbre uma amostra deste tome antes de resgatá-lo.',
  'books.detail.readPreview': 'Leia uma pré-visualização',
  'books.detail.tocHeading': 'Índice',
  'books.detail.tocEmpty': 'O conteúdo deste tome ainda não foi catalogado.',
  'books.detail.pageAbbrev': 'p. {page}',
  'books.detail.unlockedHeading': 'Entradas de Enciclopédia Desbloqueadas',
  'books.detail.unlockedOwnedNote': 'Agora parte de sua enciclopédia viva:',
  'books.detail.unlockedLockedNote':
    'Compre este tome para inscrever suas criaturas, feitiços e segredos em sua enciclopédia — e resgate',
  'books.detail.coinsAmount': '{coins} moedas',
  'books.detail.attributionsHeading': 'Atribuições & Licenciamento',
  'books.detail.attributionSource': 'Fonte',
  'books.detail.attributionLink': 'link',

  // CampaignLandingPage.tsx
  'books.campaign.liveCampaign': 'Campanha Ao Vivo',
  'books.campaign.backThisProject': 'Apoie Este Projeto',
  'books.campaign.viewStretchGoals': 'Ver Metas de Extensão',
  'books.campaign.pledged': 'Apoiado',
  'books.campaign.backers': 'Apoiadores',
  'books.campaign.pitchHeading': 'A Proposta',
  'books.campaign.backerUnlockedHeading': 'Entradas Desbloqueadas por Apoiadores',
  'books.campaign.backerUnlockedBlurb':
    'Apoiadores têm acesso antecipado ao conteúdo que flui diretamente para a enciclopédia viva. Aqui está uma amostra do que já é cânone:',
  'books.campaign.previewsEmpty': 'Novo cânone está sendo inscrito — volte conforme as metas se desbloquearem.',
  'books.campaign.choosePledge': 'Escolha Seu Apoio',
  'books.campaign.mostBacked': 'Mais Apoiado',
  'books.campaign.pledgeAmount': 'Apoiar {amount}',
  'books.campaign.pledgeFooter':
    'Os apoios são processados com segurança no checkout. As recompensas de apoio (moedas, módulos e desbloqueios de enciclopédia) são concedidas à sua conta Grymwyrd assim que o serviço de campanha entrar em funcionamento.',

  // LanguageSelect.tsx
  'books.language.label': 'Idioma',

  // PreviewModal.tsx
  'books.preview.title': 'Pré-visualização — {title}',
  'books.preview.pdfAria': 'Pré-visualização de PDF de {title}',
  'books.preview.cannotDisplay': 'Seu conjurador não consegue exibir a pré-visualização inline.',
  'books.preview.openNewTab': 'Abra a pré-visualização em uma nova aba',
  'books.preview.preparingHeading': 'A pré-visualização está sendo preparada.',
  'books.preview.preparingBody':
    'Uma amostra deste tome está sendo inscrita pelo escribório e aparecerá aqui em breve. Enquanto isso, vislumbre o que está dentro:',
  'books.preview.excerptLabel': 'Trecho — {title}',
  'books.preview.excerptFallback':
    'Além deste limiar estão páginas embebidas em pavor e maravilha. Adquira o tome para ler mais.',
  'books.preview.noExcerpt': 'Nenhum trecho foi catalogado para este volume ainda.',

  // RulesPage.tsx
  'books.rules.sectionSpells': 'Feitiços',
  'books.rules.sectionMonsters': 'Monstros',
  'books.rules.sectionMagicItems': 'Itens Mágicos',
  'books.rules.sectionWeapons': 'Armas',
  'books.rules.sectionArmor': 'Armaduras',
  'books.rules.sectionSkills': 'Perícias',
  'books.rules.entriesCount': '{entries} entradas',
  'books.rules.readingLabel': 'Lendo {label}…',
  'books.rules.noneCatalogued': 'Nenhum {label} catalogado neste sistema ainda.',
  'books.rules.browseAll': 'Navegue todos os {label} na enciclopédia →',
  'books.rules.seoTitle': 'Regras & SRD',
  'books.rules.seoDescription':
    'Navegue pelo Documento de Referência do Sistema — feitiços, monstros, itens e as regras que unem o crepúsculo eterno. SRD 5e agora, com mais sistemas por vir.',
  'books.rules.eyebrow': 'O Codex',
  'books.rules.heading': 'Regras & Referência do Sistema',
  'books.rules.intro':
    'O conteúdo de jogo aberto que alimenta Grymwyrd. Navegue por entradas relevantes às regras e mergulhe na enciclopédia completa para blocos de estatísticas e conhecimento. Grymwyrd vem com o SRD 5e hoje — PF2e e outros sistemas estão chegando.',
  'books.rules.loading': 'Consultando o códice…',
  'books.rules.gameSystems': 'Sistemas de Jogo',
  'books.rules.noSystems': 'Nenhum sistema de jogo está registrado ainda.',
  'books.rules.openSrd': 'Abra o SRD',
  'books.rules.lockedComingSoon': 'Bloqueado — em breve',
  'books.rules.referenceContent': '{name} — Conteúdo de Referência',
  'books.rules.releasedUnder': 'Lançado sob {license}',
  'books.rules.licenseLink': 'licença',

  // StretchGoals.tsx
  'books.stretch.goalProgressAria': 'Progresso de financiamento de {title}',
  'books.stretch.unlockedAdded': 'Desbloqueado — adicionado à enciclopédia',
  'books.stretch.percentFunded': '{pct}% financiado',
  'books.stretch.autoPopulates': 'Popula automaticamente a enciclopédia',
  'books.stretch.raisedSoFar': 'Arrecadado até agora',
  'books.stretch.backers': 'Apoiadores',
  'books.stretch.overallAria': 'Financiamento geral da campanha',
  'books.stretch.heading': 'Metas de Extensão',
} as const
